import { MenuProvider } from "@/contexts/MenuContext"
import "@fontsource/bebas-neue"
// import "@fontsource/inter/variable-full.css"
import "@fontsource/inter/latin-400.css"
import "@fontsource/inter/latin-500.css"
import "@fontsource/inter/latin-600.css"
import "@fontsource/inter/latin-700.css"
import "@fontsource/inter/latin-800.css"
import "@fontsource/fahkwang"
import React from "react"

import "./src/styles/global.css"

export const wrapRootElement = ({ element }) => {
  return <MenuProvider>{element}</MenuProvider>
}
